import React, { Component } from 'react'
import './Roles.css'
import * as languageSettings from '../Language/languageSettings'
import t from '../Language/language'
import { Config } from '../../Config'
import WhitePluseImage from '../../images/whiteplus.png'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getRoles, getAccountInfo } from '../../actions/roles'
import AuthenticationService from '../../components/Security/AuthenticationService'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import CommonLoader from '../Alerts/CommonLoader'
import { CommonConstants } from '../../Constants'
import { getPermission, checkAccess } from '../../actions/permissions'
// This component is used for Roles functionality.
class Roles extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isAddRole: null,
      isEdit: null,
      isView: null,
      IsOwner: 0,
      language: languageSettings.getCurrentLanguage(),
      showCommonLoader: true
    }
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.displayrecords = this.displayrecords.bind(this)
    this.createNewRole = this.createNewRole.bind(this)
    this.editRole = this.editRole.bind(this)
    this.renderAddButton = this.renderAddButton.bind(this)
    this.props.getPermission()
  }

  // Getting roles for the user and checking roles permission
  componentWillMount () {
    this.props.getRoles(() => {
      this.props.getAccountInfo()
      this.setState({ showCommonLoader: false })
    })
  }

  // Edit Display
  editRole (roleID) {
    const { language } = this.state
    const url = this.editRoles(roleID)
    if (checkAccess(CommonConstants.userPermissions.EditRole)) {
      return (
        <Td className='cdet'>
          <a className='Edit' href={url} > {t[language].viewedit}
            <span> <br /> {t[language].role} </span>
          </a>
        </Td>
      )
    }
  }
  // Creating a new rol
  createNewRole () {
    if (this.authService.isAdmin()) {
      window.location.href = '/admin/settings/roles/addRoles'
    } else {
      window.location.href = '/settings/roles/addRoles'
    }
  }
  // Editing role
  editRoles (roleID) {
    let url = null
    if (this.authService.isAdmin()) {
      url = '/admin/settings/roles/editRoles?uuid=' + this.authService.getUUID() + '&roleuid=' + roleID
    } else {
      url = '/settings/roles/editRoles?roleuid=' + roleID
    }
    return url
  }
  // Displaying the list of roles.
  displayrecords (getRoles) {
    if (getRoles && getRoles.data !== undefined && getRoles.status !== false) {
      let result = getRoles.data.map((item, index) => {
        return (
          <Tr className='tdata clear mediaspace' key={index}>
            <Td className={(checkAccess(CommonConstants.userPermissions.EditRole)) ? 'editTh' : 'hidden'}>{this.editRole(item.Role_UID)}</Td>
            <Td>{item.Company_Name}</Td>
            <Td>{item.Role_Name}</Td>
            <Td>{item.Role_Description}</Td>
            <Td>
              <div className='divWord'>
                {item.UserName}
              </div>
            </Td>
          </Tr>
        )
      })
      return result
    }
  }
  // Displaying Add role button for User.
  renderAddButton () {
    const { language } = this.state
    // Admin will not have the permission for adding a role.
    if (!this.authService.isAdmin()) {
      return (
        <div onClick={this.createNewRole}><span className={checkAccess(CommonConstants.userPermissions.AddRole) ? 'additem' : 'hidden'}>
          <img src={WhitePluseImage} alt='WhitePluseImage' className='AddButton' translate='' key='  Add a Role' />{t[language].addarole}</span>
        </div>
      )
    }
  }
  render () {
    let getRoles = this.props.roles.rolesDetails
    const { language } = this.state
    return (
      <section className='roles'>
        <div className='settings forms'>
          <div className='settings_plug clear'>
            <div className='settings_search clear'>
              <h3 className='clear' translate='' key='roles'>{t[language].roles}</h3>
              {this.renderAddButton()}
            </div>
          </div>
        </div>
        <div className='settings_plug clear storeHeight'>
          <div className='settings_list'>
            <div className='ctable'>
              <Table>
                <Thead>
                  <Tr className='theader clear'>
                    <Th className={(checkAccess(CommonConstants.userPermissions.EditRole)) ? 'editTh' : 'hidden'} />
                    <Th className='companyTh'><span > {t[language].company}</span></Th>
                    <Th className='roleTh'><span translate='' key='role'>{t[language].role}</span></Th>
                    <Th className='descTh'><span translate='' key='roledescription'> {t[language].roledescription}</span></Th>
                    <Th><span translate='' key='users'> {t[language].users} </span></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {!this.state.showCommonLoader ? this.displayrecords(getRoles) : '' }
                </Tbody>
              </Table>
              {this.state.showCommonLoader
                ? <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} /> : ''
              }
            </div>
          </div>
        </div>
      </section>
    )
  }
}

function mapStateToProps (state) {
  return {
    roles: state.roles
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getRoles: getRoles,
      getAccountInfo: getAccountInfo,
      getPermission: getPermission
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(Roles)



// WEBPACK FOOTER //
// ./src/components/Roles/Roles.js